import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from './item';

export class PasswordInput extends Component {

  static propTypes = {
    value: PropTypes.string.isRequired,
    onChange : PropTypes.func.isRequired,
    status: PropTypes.object,
    isValid: PropTypes.func,
    showError: PropTypes.bool,
    showSuccess: PropTypes.bool,
    showOnChange: PropTypes.bool,
    showWarning: PropTypes.bool,
    showOnBlur: PropTypes.bool,
    onBlur: PropTypes.func,
    type: PropTypes.string,
    onCheck: PropTypes.func
  };

  isValid = (password) => {
    if(typeof this.props.isValid !== 'undefined')
      return password.length > 7 && this.props.isValid(password);

    return password.length > 7;
  }

  render() {
    return (
      <Input
        icon="lock"
        placeholder= "Password"
        isValid={ this.isValid }
        status={ this.props.status || { success : '' , error: 'Le mot de passe doit au moins comporter 8 caratères' } }
        type="password"
        { ...this.props }
        />
    );
  }
}

export default PasswordInput;



// WEBPACK FOOTER //
// ./src/helper/form/input/password.js